{% block hueb_seo_canonical %}
    <template v-if="richSnippets">
        <sw-inherit-wrapper v-model:value="richSnippets.additional1"
                            :hasParent="!!parentRichSnippets.id"
                            :inheritedValue="parentRichSnippets.additional1">
            <template #content="props">
                <mt-text-field
                    :mapInheritance="props"
                    :disabled="!active || props.isInherited"
                    :helpText="$tc('hueb-seo.card.canonical.helpTag')"
                    :label="$tc('hueb-seo.card.canonical.labelTag')"
                    :placeholder="$tc('hueb-seo.card.canonical.placeholderTag')"
                    :value="props.currentValue"
                    @update:value="props.updateCurrentValue"></mt-text-field>
            </template>
        </sw-inherit-wrapper>
    </template>
{% endblock %}
